import { Radio } from "antd";
import type { RadioChangeEvent } from "antd";

import { FeedbackQuestion } from "../candidate-feedback.types";

import styles from "./FeedbackScaleQuestion.module.css";

interface FeedbackScaleQuestionProps {
  question: FeedbackQuestion;
  value?: number;
  onChange: (questionId: number, value: number) => void;
}

export function FeedbackScaleQuestion({ question, value, onChange }: FeedbackScaleQuestionProps) {
  const handleChange = (e: RadioChangeEvent) => {
    onChange(question.questionId, e.target.value as number);
  };

  const sortedOptions = [...(question.options || [])].sort((a, b) => a.displayOrder - b.displayOrder);
  const questionLabelId = `question-label-${question.questionId}`;

  return (
    <div className={styles.questionContainer}>
      <p id={questionLabelId} className={styles.questionText}>
        {question.text.value}
      </p>
      <Radio.Group
        size="large"
        value={value}
        onChange={handleChange}
        className={styles.optionsContainer}
        aria-labelledby={questionLabelId}
      >
        {sortedOptions.map((option) => (
          <Radio key={option.optionId} value={option.value} className={styles.option}>
            {option.label.value}
          </Radio>
        ))}
      </Radio.Group>
    </div>
  );
}
